const ImageLayout = ({
  layout,
}) => {
  return (
    <img key={layout.id} className="project-gallery__layout__image" src={layout.image.url} />
  );
};


export default ImageLayout;
